export default "__VITE_ASSET__BWLf_M5Q__"